export default [
  {
    icon: 'mdi-close',
    title: 'Hapus Sekolah',
    event: 'onHapusSekolah',
    akses: 'psp-peserta-diklat-verval.delete',
  },
  {
    icon: 'mdi-account-check',
    title: 'Periksa',
    event: 'onVerval',
    akses: 'psp-peserta-diklat-guru-pkp.verval',
  },
  {
    icon: 'mdi-transfer',
    title: 'Pindahkkan Kepala Sekolah',
    event: 'onPindahKasek',
    akses: 'psp-peserta-diklat-verval.pindah-kasek',
  },
  {
    icon: 'mdi-close',
    title: 'Batal Pindah Kepala Sekolah',
    event: 'onBatalPindahKasek',
    akses: 'psp-peserta-diklat-verval.batal-pindah-kasek',
  },
  {
    icon: 'mdi-close',
    title: 'Batal Verval',
    event: 'onBatalVerval',
    akses: 'psp-peserta-diklat-guru-pkp.batal-verval',
  },
  {
    icon: 'mdi-close',
    title: 'Batalkan Peserta',
    event: 'onBatalGanti',
    akses: 'psp-peserta-diklat-verval.batal-ganti',
  },
  {
    icon: 'mdi-pencil',
    title: 'Ubah Peserta',
    event: 'onUbahPeserta',
    akses: 'psp-peserta-diklat-guru-pkp.update',
  },
  {
    icon: 'mdi-sync',
    title: 'Sinkron Ulang ke SIM Diklat',
    event: 'onSinkron',
    akses: 'psp-peserta-diklat-verval.sinkronisasi',
  },
];
